import {toastr} from 'react-redux-toastr';
import {setErrorList} from './actionTypes';

export const defaultErrorAction = (error) => dispatch => {
    return dispatch(toastError(error));                
};

export const toastError = (error) => dispatch => {
    if(typeof error === 'string') {
        toastr.error(error);
    } else if(error.message) {
        toastr.error(error.message);
    } else if(error && error.length) {
        dispatch(displayErrorList(error));
    }

    return null;
};

export const displayErrorList = (errorStringArray) => dispatch => {
    dispatch(setErrorList(errorStringArray));
    scrollToErrorList();
};

export const scrollToErrorList = () => {
    const elementToScroll = document.querySelectorAll('#sharedErrorList');
  
    if(elementToScroll && elementToScroll.length) {
        setTimeout(() => {
            elementToScroll[0].scrollIntoView();
        }, 600); // execute scrolling after a period of time to allow rendering to execute other prior animations
    }
};



// WEBPACK FOOTER //
// ./src/features/shared/error/errorManager.js